"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = executeOrderFlowChecks;
const oms_1 = require("domain-model/types/oms");
const domain_model_1 = __importDefault(require("domain-model"));
const properties_1 = __importDefault(require("./properties"));
const moment = require('moment');
const isVindenOrSystembolagetOrder = (order) => {
    return (order.orderOrigin === oms_1.OrderOrigin.systembolaget ||
        order.orderFullfillmentCenter?.id ===
            domain_model_1.default.orderFullfillmentCenter.VINDEN_ORDER_FULLFILLMENT_CENTER_ID);
};
const orderFlowChecks = [
    {
        state: oms_1.OrderState.received,
        rules: [
            {
                name: 'Grundläggande kontroller för att skicka en order till lager',
                checks: [
                    {
                        evaluator: (order) => !order.needSpecialHandling,
                        description: 'Ordern behöver inte specialbehandling',
                        checkFailedMessage: 'Ordern behöver specialbehandling',
                    },
                    {
                        evaluator: (order) => properties_1.default.hasCustomerAllowedToOrder(order),
                        description: 'Kunden får beställa',
                        checkFailedMessage: 'Kunden är blockad eller inte godkänd',
                    },
                    {
                        evaluator: (order) => properties_1.default.hasADeliveryDate(order),
                        description: 'Ordern har leveransdatum',
                        checkFailedMessage: 'Ordern saknar leveransdatum',
                    },
                    {
                        evaluator: (order) => properties_1.default.hasNoRemarksOrIsDropshipping(order),
                        description: 'Det finns inga kundkommentarer',
                        checkFailedMessage: 'Det finns kundkommentarer',
                    },
                    {
                        evaluator: (order) => properties_1.default.isNotABackOrder(order),
                        description: 'Ordern är inte en restorder - En restorder hanteras alltid manuellt',
                        checkFailedMessage: 'Ordern är en restorder - En restorder hanteras alltid manuellt',
                    },
                    {
                        evaluator: (order) => !properties_1.default.hasOldArticles(order),
                        description: 'Det finns inga gamla artiklar på ordern',
                        checkFailedMessage: 'Det finns gamla artiklar på ordern',
                    },
                    {
                        evaluator: (order) => properties_1.default.hasValidPermitsForPurchase(order),
                        description: 'Kunden innehar rätt tillstånd för att få köpa artiklarna',
                        checkFailedMessage: 'Kunden saknar alkoholtillstånd',
                    },
                    {
                        evaluator: (order) => !properties_1.default.isMissingSupplierCustomer(order),
                        description: 'Ordern har kund',
                        checkFailedMessage: 'Ordern saknar kund',
                    },
                    {
                        evaluator: (order) => properties_1.default.hasCompleteCollies(order),
                        description: 'Ordern har kompletta kolli',
                        checkFailedMessage: 'Ordern har ofullständiga kolli',
                    },
                ],
                dontEvaluateMoreRulesWhenFails: true,
            },
            {
                prerequisite: (order) => !!order.requiresEMCS,
                name: 'En order som kräver EMCS skickas till väntar-state om den saknar ARCnummer',
                checks: [
                    {
                        evaluator: (order) => !order.ARCNumber,
                        description: 'ARCnummer saknas',
                    },
                ],
                onAllChecksPassAction: 'v1.order.setInWaitingForAdvancePaymentState',
            },
            {
                name: 'Skicka ordern till lager när alla artiklar finns i lager',
                checks: [
                    {
                        evaluator: (order, stockInfoOnOfcReport) => properties_1.default.hasAllArticlesOnOrderInStock(order, stockInfoOnOfcReport),
                        description: 'Alla artiklar finns i lager',
                        checkFailedMessage: 'Någon eller några artiklar saknas i lager',
                    },
                ],
                onAllChecksPassAction: 'v1.order.sendToWarehouse',
            },
            {
                name: 'Skicka ordern till väntar på inleverans om någon artikel saknas i lager',
                checks: [
                    {
                        evaluator: (order, stockInfoOnOfcReport) => !properties_1.default.hasAllArticlesOnOrderInStock(order, stockInfoOnOfcReport),
                        description: 'Det är lågt lagersaldo på några artiklarna',
                    },
                ],
                onAllChecksPassAction: 'v1.order.setInWaitingForRestockState',
            },
        ],
    },
    {
        state: oms_1.OrderState.waitingForRestock,
        rules: [
            {
                name: 'Skicka ordern till lager när alla artiklar finns i lager',
                checks: [
                    {
                        evaluator: (order, stockInfoOnOfcReport) => properties_1.default.hasAllArticlesOnOrderInStock(order, stockInfoOnOfcReport),
                        description: 'Alla artiklar finns i lager',
                        checkFailedMessage: 'Någon eller några artiklar saknas i lager',
                    },
                ],
                onAllChecksPassAction: 'v1.order.sendToWarehouse',
            },
        ],
    },
    {
        state: oms_1.OrderState.approvedByDropshipSupplier,
        rules: [
            {
                prerequisite: (order) => !domain_model_1.default.order.isCoPackOrder(order),
                name: 'Markera en order som levererad så snart den är godkänd av dropship-leverantör och leveransdatumet har passerats',
                checks: [
                    {
                        evaluator: (order) => moment(order.deliveryDate).isBefore(moment()),
                        description: 'Order har passerat leveransdatum och kommer sättas som levererad',
                        checkFailedMessage: 'När ordern passerar leveransdatum så kommer den sättas som levererad',
                    },
                ],
                onAllChecksPassAction: 'v1.order.deliverOrder',
            },
        ],
    },
    {
        state: oms_1.OrderState.enRoute,
        rules: [
            {
                // From exacta we only get a signal that the order is picked. We do not get any shipping confirmation.
                // however exacta is a copack ofc
                // add to that the fact that exacta invoice systembolaget orders but horeca orders are invoiced by us
                // so again we have super special stuff for vinden and now also systembolaget. Sigh...
                prerequisite: (order) => !isVindenOrSystembolagetOrder(order),
                name: 'Markera en order som levererad om den inte går med copackflödet och leveransdatumet har passerats',
                checks: [
                    {
                        evaluator: (order) => moment(order.deliveryDate).isBefore(moment()),
                        description: 'Order har passerat leveransdatum och kommer sättas som levererad',
                        checkFailedMessage: 'När ordern passerar leveransdatum så kommer den sättas som levererad',
                    },
                ],
                onAllChecksPassAction: 'v1.order.deliverOrder',
            },
        ],
    },
    {
        state: oms_1.OrderState.delivered,
        rules: [
            {
                name: 'Fakturera en order så snart den är levererad om kunden inte kräver samfaktura',
                prerequisite: (order) => !properties_1.default.requiresGroupInvoice(order),
                checks: [
                    {
                        evaluator: () => true,
                        description: 'Kunden kräver inte samfaktura',
                        checkFailedMessage: 'Kunden kräver samfaktura',
                    },
                ],
                onAllChecksPassAction: 'v1.order.invoiceOrder',
            },
        ],
    },
];
function executeOrderFlowChecks(order, stockInfoOnOfcReport) {
    const result = {
        appliedRules: [],
        actions: [],
    };
    if (!order.orderFullfillmentCenter) {
        return result;
    }
    if (order.orderFlowType === 'freshx') {
        return result;
    }
    const orderFlow = orderFlowChecks.find(x => x.state === order.orderState);
    if (!orderFlow) {
        return result;
    }
    for (const rule of orderFlow.rules) {
        const orderFlowRuleResult = {
            appliedChecks: [],
            name: rule.name,
        };
        if (rule.prerequisite && !rule.prerequisite(order)) {
            continue;
        }
        for (const check of rule.checks) {
            const checkResult = {
                description: check.description || '',
                checkFailedMessage: check.checkFailedMessage || '',
                passed: check.evaluator(order, stockInfoOnOfcReport),
            };
            orderFlowRuleResult.appliedChecks.push(checkResult);
        }
        result.appliedRules.push(orderFlowRuleResult);
        if (orderFlowRuleResult.appliedChecks.every(x => x.passed)) {
            orderFlowRuleResult.action = rule.onAllChecksPassAction;
            if (rule.onAllChecksPassAction) {
                // when we have found an action we stop the search
                break;
            }
        }
        else {
            if (rule.dontEvaluateMoreRulesWhenFails) {
                // when a rule fails and we should not evaluate more rules we stop the search
                break;
            }
        }
    }
    result.actions = result.appliedRules
        .map(x => x.action)
        .filter(x => !!x);
    return result;
}
